import { FeeList } from "@/domain/ticket-selection";
import { FeeBaseType, MathHelper, MathOperationType } from "webshop-modules";

export class TicketFeeCalculator {
    public static calculateFeeFor(ticketPriceList: number[], feeList: FeeList[]): number {
        let feeSum = 0;

        if (!this.hasAttachedFees(feeList)) {
            return feeSum;
        }

        feeList.forEach(fee => {
            feeSum = this.addFeeValueTo(feeSum, fee, ticketPriceList);
        });

        return feeSum;
    }

    private static addFeeValueTo(sum: number, fee: FeeList, ticketPrices: number[]): number {
        if (fee.mathOperationType === MathOperationType.Multiply) {
            sum += this.multiplyByBase(fee.baseType, ticketPrices, fee.value);
        } else if (fee.mathOperationType === MathOperationType.Addition) {
            sum += this.addByBase(fee.baseType, ticketPrices, fee.value)
        }

        return sum;
    }

    private static multiplyByBase(type: FeeBaseType, ticketPrices: number[], feeValue: number): number {
        if (type === FeeBaseType.TicketAmount) {
            return this.multiplyFeeWithTicketCount(ticketPrices.length, feeValue)
        } else {
            return this.multiplyFeeWithEachTicket(ticketPrices, feeValue);
        }
    }

    private static addByBase(type: FeeBaseType, ticketPrices: number[], feeValue: number): number {
        if (type === FeeBaseType.TicketAmount) {
            return this.multiplyFeeWithTicketCount(ticketPrices.length, feeValue)
        } else {
            return MathHelper.roundValueToDecimals(feeValue, 2);
        }
    }

    private static multiplyFeeWithEachTicket(ticketPriceList: number[], fee: number): number {
        let value = 0;

        ticketPriceList.forEach(price => {
            value += MathHelper.roundValueToDecimals(price * fee, 2);
        });

        return value;
    }

    private static multiplyFeeWithTicketCount(count: number, fee: number): number {
        return MathHelper.roundValueToDecimals(count * fee, 2);
    }

    private static hasAttachedFees(fees: FeeList[]): boolean {
        return !!fees && fees.length > 0;
    }

}